"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockedLegalEntityResponseWithCount = exports.mockedLegalEntityResponse = exports.mockedLegalEntityUpdateRequest = exports.mockedLegalEntityCreateRequest = void 0;
const date_util_1 = require("../../utils/date.util");
exports.mockedLegalEntityCreateRequest = {
  name: 'Legal Name',
  details: '',
  isTaxes: true
};
exports.mockedLegalEntityUpdateRequest = {
  name: 'Legal One',
  details: '',
  isTaxes: false
};
exports.mockedLegalEntityResponse = {
  id: 1,
  name: 'Legal Name',
  details: '',
  isTaxes: true,
  isDeleted: false,
  createdAt: date_util_1.takeDaysFromNow(),
  updatedAt: null
};
exports.mockedLegalEntityResponseWithCount = {
  items: [exports.mockedLegalEntityResponse],
  count: 1
};